import api from "../../core/app/api";

export const getPagesRequest = async () => api.get('pages');



